export default "__VITE_ASSET__bc9h3LZB__"